/* -------------------------------------------------------------------------- */
/*                                Radio group styles                               */
/* -------------------------------------------------------------------------- */

:host {
  @apply inline-block;
}

.bq-radio-group {
  @apply m-b-0 m-i-0;

  &:not(.has-fieldset) {
    @apply border-0 m-b-0 m-i-0 p-b-0 p-i-0;
  }

  &--horizontal {
    @apply flex;
  }

  &--vertical {
    @apply flex flex-col;
  }
}
